/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Area,
    AreaFromJSON,
    AreaToJSON,
} from '../models/Area';
import {
    type Machine,
    MachineFromJSON,
    MachineToJSON,
} from '../models/Machine';
import {
    type MachinePart,
    MachinePartFromJSON,
    MachinePartToJSON,
} from '../models/MachinePart';
import {
    type PageResponseMachine,
    PageResponseMachineFromJSON,
    PageResponseMachineToJSON,
} from '../models/PageResponseMachine';

export interface AddPartRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    machinePart: MachinePart;
}

export interface CreateAreaRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    area: Area;
}

export interface CreateMachineRequest {
    /**
     * 
     */
    machine: Machine;
}

export interface DeleteAreaRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    areaId: string;
}

export interface DeleteMachineRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteMachineLegacyRequest {
    /**
     * 
     */
    id: string;
}

export interface GetAll2Request {
    /**
     * 
     */
    pageNumber?: number;
    /**
     * 
     */
    perPage?: number;
    /**
     * 
     */
    sort?: string;
}

export interface GetAllMachinePartsLegacyRequest {
    /**
     * 
     */
    id: string;
}

export interface GetAreaRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    areaId: string;
}

export interface GetAreasRequest {
    /**
     * 
     */
    id: string;
}

export interface GetMachineRequest {
    /**
     * 
     */
    id: string;
}

export interface GetMachineLegacyRequest {
    /**
     * 
     */
    id: string;
}

export interface GetPartsInAreaRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    areaId: string;
}

export interface RemovePartRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    partId: string;
}

export interface SaveMachineLegacyRequest {
    /**
     * 
     */
    machine: Machine;
}

export interface UpdateAreaRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    areaId: string;
    /**
     * 
     */
    area: Area;
}

export interface UpdateMachineRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    machine: Machine;
}

/**
 * 
 */
export class MachineControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for addPart without sending the request
     */
    async addPartRequestOpts(requestParameters: AddPartRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addPart().'
            );
        }

        if (requestParameters['machinePart'] == null) {
            throw new runtime.RequiredError(
                'machinePart',
                'Required parameter "machinePart" was null or undefined when calling addPart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machines/{id}/parts`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartToJSON(requestParameters['machinePart']),
        };
    }

    /**
     */
    async addPartRaw(requestParameters: AddPartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        const requestOptions = await this.addPartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async addPart(requestParameters: AddPartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.addPartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createArea without sending the request
     */
    async createAreaRequestOpts(requestParameters: CreateAreaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createArea().'
            );
        }

        if (requestParameters['area'] == null) {
            throw new runtime.RequiredError(
                'area',
                'Required parameter "area" was null or undefined when calling createArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machines/{id}/areas`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AreaToJSON(requestParameters['area']),
        };
    }

    /**
     */
    async createAreaRaw(requestParameters: CreateAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Area>> {
        const requestOptions = await this.createAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AreaFromJSON(jsonValue));
    }

    /**
     */
    async createArea(requestParameters: CreateAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Area> {
        const response = await this.createAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMachine without sending the request
     */
    async createMachineRequestOpts(requestParameters: CreateMachineRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['machine'] == null) {
            throw new runtime.RequiredError(
                'machine',
                'Required parameter "machine" was null or undefined when calling createMachine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machines`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachineToJSON(requestParameters['machine']),
        };
    }

    /**
     */
    async createMachineRaw(requestParameters: CreateMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        const requestOptions = await this.createMachineRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async createMachine(requestParameters: CreateMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.createMachineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteArea without sending the request
     */
    async deleteAreaRequestOpts(requestParameters: DeleteAreaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteArea().'
            );
        }

        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling deleteArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machines/{id}/areas/{areaId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{areaId}', encodeURIComponent(String(requestParameters['areaId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteAreaRaw(requestParameters: DeleteAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteArea(requestParameters: DeleteAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAreaRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteMachine without sending the request
     */
    async deleteMachineRequestOpts(requestParameters: DeleteMachineRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machines/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteMachineRaw(requestParameters: DeleteMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteMachineRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachine(requestParameters: DeleteMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachineRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteMachineLegacy without sending the request
     */
    async deleteMachineLegacyRequestOpts(requestParameters: DeleteMachineLegacyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachineLegacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteMachineLegacyRaw(requestParameters: DeleteMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteMachineLegacyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachineLegacy(requestParameters: DeleteMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachineLegacyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAll2 without sending the request
     */
    async getAll2RequestOpts(requestParameters: GetAll2Request): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAll2Raw(requestParameters: GetAll2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageResponseMachine>> {
        const requestOptions = await this.getAll2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageResponseMachineFromJSON(jsonValue));
    }

    /**
     */
    async getAll2(requestParameters: GetAll2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageResponseMachine> {
        const response = await this.getAll2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllMachinePartsLegacy without sending the request
     */
    async getAllMachinePartsLegacyRequestOpts(requestParameters: GetAllMachinePartsLegacyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAllMachinePartsLegacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine/{id}/parts`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllMachinePartsLegacyRaw(requestParameters: GetAllMachinePartsLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachinePart>>> {
        const requestOptions = await this.getAllMachinePartsLegacyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachinePartFromJSON));
    }

    /**
     */
    async getAllMachinePartsLegacy(requestParameters: GetAllMachinePartsLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachinePart>> {
        const response = await this.getAllMachinePartsLegacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllMachines without sending the request
     */
    async getAllMachinesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machines`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllMachinesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Machine>>> {
        const requestOptions = await this.getAllMachinesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachineFromJSON));
    }

    /**
     */
    async getAllMachines(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Machine>> {
        const response = await this.getAllMachinesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllMachinesLegacy without sending the request
     */
    async getAllMachinesLegacyRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine/all`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllMachinesLegacyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Machine>>> {
        const requestOptions = await this.getAllMachinesLegacyRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachineFromJSON));
    }

    /**
     */
    async getAllMachinesLegacy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Machine>> {
        const response = await this.getAllMachinesLegacyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getArea without sending the request
     */
    async getAreaRequestOpts(requestParameters: GetAreaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getArea().'
            );
        }

        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling getArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machines/{id}/areas/{areaId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{areaId}', encodeURIComponent(String(requestParameters['areaId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAreaRaw(requestParameters: GetAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Area>> {
        const requestOptions = await this.getAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AreaFromJSON(jsonValue));
    }

    /**
     */
    async getArea(requestParameters: GetAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Area> {
        const response = await this.getAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAreas without sending the request
     */
    async getAreasRequestOpts(requestParameters: GetAreasRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAreas().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machines/{id}/areas`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAreasRaw(requestParameters: GetAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Area>>> {
        const requestOptions = await this.getAreasRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AreaFromJSON));
    }

    /**
     */
    async getAreas(requestParameters: GetAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Area>> {
        const response = await this.getAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMachine without sending the request
     */
    async getMachineRequestOpts(requestParameters: GetMachineRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machines/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getMachineRaw(requestParameters: GetMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        const requestOptions = await this.getMachineRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async getMachine(requestParameters: GetMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.getMachineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMachineLegacy without sending the request
     */
    async getMachineLegacyRequestOpts(requestParameters: GetMachineLegacyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachineLegacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getMachineLegacyRaw(requestParameters: GetMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        const requestOptions = await this.getMachineLegacyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async getMachineLegacy(requestParameters: GetMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.getMachineLegacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPartsInArea without sending the request
     */
    async getPartsInAreaRequestOpts(requestParameters: GetPartsInAreaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPartsInArea().'
            );
        }

        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling getPartsInArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machines/{id}/areas/{areaId}/parts`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{areaId}', encodeURIComponent(String(requestParameters['areaId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPartsInAreaRaw(requestParameters: GetPartsInAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachinePart>>> {
        const requestOptions = await this.getPartsInAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachinePartFromJSON));
    }

    /**
     */
    async getPartsInArea(requestParameters: GetPartsInAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachinePart>> {
        const response = await this.getPartsInAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removePart without sending the request
     */
    async removePartRequestOpts(requestParameters: RemovePartRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removePart().'
            );
        }

        if (requestParameters['partId'] == null) {
            throw new runtime.RequiredError(
                'partId',
                'Required parameter "partId" was null or undefined when calling removePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machines/{id}/parts/{partId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{partId}', encodeURIComponent(String(requestParameters['partId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async removePartRaw(requestParameters: RemovePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        const requestOptions = await this.removePartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async removePart(requestParameters: RemovePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.removePartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for saveMachineLegacy without sending the request
     */
    async saveMachineLegacyRequestOpts(requestParameters: SaveMachineLegacyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['machine'] == null) {
            throw new runtime.RequiredError(
                'machine',
                'Required parameter "machine" was null or undefined when calling saveMachineLegacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machine`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachineToJSON(requestParameters['machine']),
        };
    }

    /**
     */
    async saveMachineLegacyRaw(requestParameters: SaveMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        const requestOptions = await this.saveMachineLegacyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async saveMachineLegacy(requestParameters: SaveMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.saveMachineLegacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateArea without sending the request
     */
    async updateAreaRequestOpts(requestParameters: UpdateAreaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateArea().'
            );
        }

        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling updateArea().'
            );
        }

        if (requestParameters['area'] == null) {
            throw new runtime.RequiredError(
                'area',
                'Required parameter "area" was null or undefined when calling updateArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machines/{id}/areas/{areaId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{areaId}', encodeURIComponent(String(requestParameters['areaId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AreaToJSON(requestParameters['area']),
        };
    }

    /**
     */
    async updateAreaRaw(requestParameters: UpdateAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Area>> {
        const requestOptions = await this.updateAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AreaFromJSON(jsonValue));
    }

    /**
     */
    async updateArea(requestParameters: UpdateAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Area> {
        const response = await this.updateAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMachine without sending the request
     */
    async updateMachineRequestOpts(requestParameters: UpdateMachineRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMachine().'
            );
        }

        if (requestParameters['machine'] == null) {
            throw new runtime.RequiredError(
                'machine',
                'Required parameter "machine" was null or undefined when calling updateMachine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machines/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachineToJSON(requestParameters['machine']),
        };
    }

    /**
     */
    async updateMachineRaw(requestParameters: UpdateMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        const requestOptions = await this.updateMachineRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async updateMachine(requestParameters: UpdateMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.updateMachineRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
